import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const RmrMerchant_ = z.object({
  teamId: z.string(),
  name: z.string(),
  accountId: z.string(),
});
export const RmrMerchant: z.ZodType<RmrMerchant> = RmrMerchant_;
export interface RmrMerchant extends z.infer<typeof RmrMerchant_> {}

export const getRmrMerchants = unaryRpc({
  name: "getRmrMerchants" as const,
  input: z.object({}),
  output: z.object({ merchants: z.array(RmrMerchant) }),
});
